var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#A1A1A1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33329 27.9998C4.59996 27.9998 3.97218 27.7387 3.44996 27.2165C2.92774 26.6943 2.66663 26.0665 2.66663 25.3332V10.6665C2.66663 9.93317 2.92774 9.30539 3.44996 8.78317C3.97218 8.26095 4.59996 7.99984 5.33329 7.99984H10.6666V5.33317C10.6666 4.59984 10.9277 3.97206 11.45 3.44984C11.9722 2.92762 12.6 2.6665 13.3333 2.6665H18.6666C19.4 2.6665 20.0277 2.92762 20.55 3.44984C21.0722 3.97206 21.3333 4.59984 21.3333 5.33317V7.99984H26.6666C27.4 7.99984 28.0277 8.26095 28.55 8.78317C29.0722 9.30539 29.3333 9.93317 29.3333 10.6665V25.3332C29.3333 26.0665 29.0722 26.6943 28.55 27.2165C28.0277 27.7387 27.4 27.9998 26.6666 27.9998H5.33329ZM5.33329 25.3332H26.6666V10.6665H5.33329V25.3332ZM13.3333 7.99984H18.6666V5.33317H13.3333V7.99984Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.5dd426a6220a8206058cdfc9b3860bf7.svg";
export { ForwardRef as ReactComponent };